import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { LIBRARY_TABS } from '../constant'
import { fetchLibraryCounts } from 'api/library'

const LibraryTabs = (props) => {
  const {
    selectedCount = 0,
    activeTab,
    handleTabChange,
    showSelectedTab = false,
    refreshKey = 0,
  } = props

  const [counts, setCounts] = useState({
    all: 0,
    original: 0,
    variants: 0,
  })

  const { t } = useTranslation()

  useEffect(() => {
    let cancelled = false

    fetchLibraryCounts().then((response) => {
      if (cancelled || !response.success) {
        return
      }

      const { original, variations } = response.data

      setCounts({
        all: original + variations,
        original,
        variants: variations,
      })
    })

    return () => {
      cancelled = true
    }
  }, [refreshKey])

  return (
    <div className='library-tabs'>
      <button
        type="button"
        onClick={() => handleTabChange(LIBRARY_TABS.ALL)}
        className={`library-tabs__tab ${activeTab === LIBRARY_TABS.ALL ? 'active' : ''}`}
      >
        <span>
          {t('Library.Tabs.all')}
        </span>

        <span className='library-tabs__tab-count'>{counts.all}</span>
      </button>

      <button
        type="button"
        onClick={() => handleTabChange(LIBRARY_TABS.ORIGINAL)}
        className={`library-tabs__tab ${activeTab === LIBRARY_TABS.ORIGINAL ? 'active' : ''}`}
      >
        <span>
          {t('Library.Tabs.originals')}
        </span>

        <span className='library-tabs__tab-count'>{counts.original}</span>
      </button>

      <button
        type="button"
        onClick={() => handleTabChange(LIBRARY_TABS.VARIANTS)}
        className={`library-tabs__tab ${activeTab === LIBRARY_TABS.VARIANTS ? 'active' : ''}`}
      >
        <span>
          {t('Library.Tabs.variants')}
        </span>

        <span className='library-tabs__tab-count'>{counts.variants}</span>
      </button>

      {showSelectedTab && (
        <button
          type="button"
          onClick={() => handleTabChange(LIBRARY_TABS.SELECTED)}
          className={`library-tabs__tab ${activeTab === LIBRARY_TABS.SELECTED ? 'active' : ''}`}
        >
          <span>
            {t('Library.Tabs.selected')}
          </span>

          <span className='library-tabs__tab-count'>{selectedCount}</span>
        </button>
      )}
    </div>
  )
}

LibraryTabs.propTypes = {
  selectedCount: PropTypes.number,
  activeTab: PropTypes.string.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  showSelectedTab: PropTypes.bool,
  refreshKey: PropTypes.number,
}

export default LibraryTabs